import logo from './logo.svg';
import './App.css';
import { useEffect, useState } from 'react';
import MyOrdersScreen from "./myOrdersScreen.js";
import MyLoginScreen from "./myLoginScreen.js";
import MyCustomerDeliveryReport from "./myCustomerDeliveryReport.js";
import MyUserManagement from "./myUserManagement.js";


import {UserContext } from "./Context.js";
import { Route, BrowserRouter as Router, Switch, BrowserRouter } from "react-router-dom";

function App() {
  const [val,setVal]=useState('I was here')
  return (
    <BrowserRouter>
    <div className="App">
      <UserContext.Provider value={{val,setVal}}>
        <Switch>
          <Route path="/" exact component={MyLoginScreen} />
          <Route path="/MyUserManagement/" exact component={MyUserManagement} />
          <Route path="/MyLoginScreen" component={MyLoginScreen} />
          <Route path="/MyOrdersScreen/" exact component={MyOrdersScreen} />
          <Route path="/MyCustomerDeliveryReport/" exact component={MyCustomerDeliveryReport} />
        </Switch>
      </UserContext.Provider>
    </div>
    </BrowserRouter>
  );
}

export default App;
